export const API_URL = `https://api.beatport.com/v4`;
export const API_CLIENT_ID=`FwibZYraRS1YYNQATRk43JpBCagAqc4c8OuEHVON`
export const API_CLIENT_SECRET=`C2UQfKrHYlV4NzWs0HJ9f31YPAYBCt5PIWgFz2ODWiX5JvESXKxOrfGKnrFzPtFQwPAZ49jwe5ofxWavunUsdmiPiBeJDxLVNbXFlzoJ1d2uSeiO0n6GSnd11JBfJZWJ`
export const API_USERNAME="AdrienFrance"
export const API_PASSWORD="AdrienFrance123"

export const BCOLOR_GREEN = `#0ce396`;

export const DEFAULT_IMG = `https://label-engine.com/blog/wp-content/uploads/2015/06/beatport-pro.jpg`;
